import { axiosInstance } from "../helper/axios.js";
import backend from "../router/backend";

export default {
  namespaced: true,

  state: {
    courierSettings: {
      travelModes: [],
      dynamicHubRadius: [],
    },
  },

  mutations: {
    SET_TRAVEL_MODES(state, travelModes) {
      state.courierSettings.travelModes = travelModes;
    },
    SET_DYNAMIC_HUB_RADIUS(state, dynamicHubRadius) {
      state.courierSettings.dynamicHubRadius = dynamicHubRadius;
    },
  },

  actions: {
    async fetchTravelModes({ commit, state }) {
      // Eğer store'da veri varsa, yeni request atmadan onu döndür
      if (state.courierSettings.travelModes.length > 0) {
        return state.courierSettings.travelModes;
      }

      // Store boşsa, API'dan çek
      try {
        const response = await axiosInstance.get(
          backend.COURIER.SETTINGS.TRAVEL_MODES
        );
        commit("SET_TRAVEL_MODES", response.data);
      } catch (error) {
        console.error("Error fetching travel modes:", error);
        throw error;
      }
    },

    async fetchDynamicHubRadius({ commit, state }) {
      // Eğer store'da veri varsa, yeni request atmadan onu döndür
      if (state.courierSettings.dynamicHubRadius.length > 0) {
        return state.courierSettings.dynamicHubRadius;
      }

      // Store boşsa, API'dan çek
      try {
        const response = await axiosInstance.get(
          backend.COURIER.SETTINGS.DYNAMIC_HUB_RADIUS
        );
        commit("SET_DYNAMIC_HUB_RADIUS", response.data);
      } catch (error) {
        console.error("Error fetching dynamic hub radius:", error);
        throw error;
      }
    },
  },

  getters: {
    getTravelModes: (state) => state.courierSettings.travelModes,

    getTravelModeByType: (state) => (type) => {
      const mode = state.courierSettings.travelModes.find(
        (mode) => mode.value === type
      );
      return mode || null;
    },

    getDynamicHubRadius: (state) => state.courierSettings.dynamicHubRadius,

    getDynamicHubRadiusByType: (state) => (type) => {
      const radius = state.courierSettings.dynamicHubRadius.find(
        (radius) => radius.value === type
      );
      return radius || null;
    },
  },
};
